export enum StatusNotificacao {
  PENDENTE = 'PENDENTE',
  ENVIADA = 'ENVIADA',
  ENTREGUE = 'ENTREGUE',
  LIDA = 'LIDA'
}
